<template>
  <div class="vl-personal">
    <router-view></router-view>
  </div>
</template>
<script>
  export default {
    data() {
      return {}
    },
    mounted() {
      this.$_setTitle('个人中心-开放平台');
    },
    methods: {

    },
  }
</script>
<style lang="scss" scoped>
  .vl-personal {
    width: 100%;
    height: 100%;
  }
</style>